import type { SectionPhotoOption, SectionPhotoOptions } from '../../api/client'

/** A checked photograph is judged by what the model saw; an unchecked one by its caption match. */
export function photoOk(o: SectionPhotoOption): boolean {
  return o.fit != null ? o.fit >= 2 : o.matched
}

export function photoLabel(o: SectionPhotoOption): string {
  const where = o.maker ? ` · ${o.maker.brand ?? 'manufacturer'} website` : o.from_archive ? ' · archive' : ''
  if (o.fit != null) return (o.fit >= 2 ? 'Checked: of the subject' : 'Checked: not the subject') + where
  return (o.matched ? 'Of the subject (caption)' : 'Not matched') + where
}

/** "Already the lead photo of …" for a photograph another live article leads with, or null. */
export function usedOnLabel(o: SectionPhotoOption): string | null {
  const used = o.used_on ?? []
  if (used.length === 0) return null
  const first = used[0]
  const name = `“${first.title ?? 'an untitled article'}”${first.site_type === 'main' ? ' (free site)' : ''}`
  return `Already the lead photo of ${name}${used.length > 1 ? ` and ${used.length - 1} more` : ''}`
}

/** Remove photo: only when there is a photograph to remove and the photo may be changed. */
export function canRemovePhoto(featuredImageUrl: string | null | undefined, canChange: boolean): boolean {
  return canChange && !!featuredImageUrl
}

/** The question asked before Remove photo; a live piece loses it on the site too. */
export function removePhotoQuestion(published: boolean): string {
  return published
    ? 'Remove the photo from this piece? It comes off the live piece too, with its credit.'
    : 'Remove the photo from this piece? Its credit goes with it.'
}

/** The line above the archive photographs, or null when there are none. */
export function photoOptionsNote(options: SectionPhotoOptions): string | null {
  const items = options.items
  if (items.length === 0) return null
  if (options.recent) return 'The sources hold no photographs, so these are the newest in the archive. Choose one that fits the piece.'
  const matched = items.filter((o) => photoOk(o)).length
  return `${matched} of ${items.length} show the subject. Where it says what the photo shows, a model looked at it. Choosing one works out its credit again.`
}
